import Bar from "../../reusableComponents/bar";
import CountCard from "../../reusableComponents/countCard";
import TestComp from "./testComp";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import { useEffect, useState } from "react";
import GreyBadge from "../../reusableComponents/greyBackgroundBadge";
import Icon from "../../sharedComponents/icons/fontawsomeIcons";
import { paths } from "../../../paths/paths";
import { styleEnd, styleStart } from "../../../algorithms/styleDirection";
import AttachmentCard from "../../reusableComponents/attachmentCard";
import Switch from "../../sharedComponents/switch/switch";
// const Test = () => {
// const [connection, setConnection] = useState(null);
// const [inputText, setInputText] = useState("");
// const [data, setData] = useState("");
// useEffect(() => {
//   const connect = new HubConnectionBuilder()
//     .withUrl("http://163.121.36.62:82/commentHub", {
//       skipNegotiation: true,
//       transport: signalR.HttpTransportType.WebSockets,
//     })
//     .withAutomaticReconnect()
//     .build();
//   setConnection(connect);
// }, []);
// useEffect(() => {
//   if (connection) {
//     if (connection.state === "Disconnected") connection.start();

//     connection.on("ReceiveComment", (message) => {
//       setData(data + message.description);
//     });
//   }
//   // connect.on();

//   //
// }, [connection, data]);
// // useEffect(() => {
// //   if (connection) {
// //     setConnection(connection.start());
// //   }
// // }, []);

// // useEffect(() => {
// //   if (connection?.state === "Connecting") {
// //     connection
// //       .invoke()
// //       .then(() => {
// //         connection.on("ReceiveComment", (message) => {
// //           setData(data + message);
// //         });
// //       })
// //   }
// // }, [data, connection, inputText]);
// const sendMessage = async () => {
//   // if (connection) await connection.send("SendMessage", inputText);
//   setInputText("d");
// };
//   return (
//     <>
//       <input
//         value={inputText}
//         onChange={(input) => {
//           setInputText(input.target.value);
//         }}
//       ></input>
//       <button onClick={sendMessage}>Send</button>
//       <div> {data} </div>
//       {/* <Bar
//         barColor={"green"}
//         textColor={"white"}
//         total={50}
//         finished={30}
//         isCount={true}
//         width={40}
//       />
//       <CountCard
//         containerStyle={"col-2"}
//         activeColor={"pink"}
//         borderColor={"grey"}
//         borderTopColor={"red"}
//         count={20}
//         describtion={"HI DESC"}
//       /> */}
//     </>
//     // <></>
//   );
// };
const arr = [];
arr.length = 20;
const Test = () => {
  const [active, setActive] = useState(null);
  return (
    <>
      {/* <div className="d-flex flex-column">
        <div className="d-flex">
          <div className="d-flex align-items-center justify-content-start col-10">
            <div
              style={{
                backgroundImage:
                  'url("/assets/images/icons/projection-screen.png")', //change image here
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                border: "1px solid white",
              }}
            ></div>
            <p className="my-0 mx-1" style={{ fontWeight: "bold" }}>
              HIII
            </p>
          </div>
          <div className="d-flex align-items-center justify-content-end col-2">
            HIII
          </div>
        </div>
        <div className="d-flex justify-content-center px-2">
          <hr
            className="col-12 my-2"
            style={{ backgroundColor: "#707070" }}
          ></hr>
        </div>
      </div> */}
      <div
        className="my-3 w-75 m-auto px-2"
        style={{
          boxShadow: "1px 2px 7px grey",
          height: 400,
          overflowY: "auto",
        }}
      >
        <div className="" style={{ color: "red" }}>
          elmosharken
        </div>

        {Array(...arr).map((item, index) => {
          return (
            <>
              <div className="d-flex justify-content-between px-3 mt-2">
                <div className="d-flex align-items-center justify-content-start col-9">
                  <img
                    className="img-fluid"
                    style={{ borderRadius: "50%", width: 30 }}
                    src={"/assets/images/userPlaceholder.png"}
                  />
                  <div className="my-0 mx-3" style={{ fontWeight: "bold" }}>
                    HIII
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center col-3">
                  <div
                    className="p2"
                    style={{
                      border: active == 1 ? "2px solid black" : "unset",
                    }}
                  >
                    <div
                      data-toggle="tooltip"
                      data-placement="top"
                      title="red"
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: "red",
                        margin: 3,
                      }}
                      onClick={() => {
                        setActive(1);
                      }}
                    ></div>
                  </div>
                  <div
                    className="p2"
                    style={{
                      border: active == 2 ? "2px solid black" : "unset",
                    }}
                  >
                    <div
                      data-toggle="tooltip"
                      data-placement="top"
                      title="green"
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: "green",
                        margin: 3,
                      }}
                      onClick={() => {
                        setActive(2);
                      }}
                    ></div>
                  </div>

                  <div
                    className="p2"
                    style={{
                      border: active == 3 ? "2px solid black" : "unset",
                    }}
                  >
                    <div
                      data-toggle="tooltip"
                      data-placement="top"
                      title="pink"
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: "pink",
                        margin: 3,
                      }}
                      onClick={() => {
                        setActive(3);
                      }}
                    ></div>
                  </div>
                  <div
                    className="p2"
                    style={{
                      border: active == 4 ? "2px solid black" : "unset",
                    }}
                  >
                    <div
                      data-toggle="tooltip"
                      data-placement="top"
                      title="blue"
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: "blue",
                        margin: 3,
                      }}
                      onClick={() => {
                        setActive(4);
                      }}
                    ></div>
                  </div>
                  {/* <Switch /> */}
                </div>
              </div>
              <div className="d-flex justify-content-center px-2">
                <hr
                  className="col-12 my-2"
                  style={{ backgroundColor: "#707070" }}
                ></hr>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default Test;
